export const postback = {
  state: {
    init: {
      description:
        'Postback is a virtual PBX service that allows you to send a message with the necessary parameters to the specified URL after completing the transition according to the routing scheme.'
    }
  },
  url: 'URL',
  key: 'Key',
  value: 'Value',
  area: 'Enter something...'
};
